import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import resources from './translations'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: import.meta.env.DEV,
    resources,
    fallbackLng: 'en',
    detection: {
      // Check browser language only (not localStorage) for initial load
      // After login, App.tsx will override with user's database language
      order: ['navigator'],
      caches: [], // Don't cache to localStorage - let user's DB language take precedence
    },
    interpolation: {
      escapeValue: false,
    },
  })
function updateTitle() {
  document.title = i18n.t('tabTitle')
}
updateTitle()
i18n.on('languageChanged', () => {
  updateTitle()
})
export default i18n
